import {
  Component,
  computed,
  inject,
  ChangeDetectionStrategy,
} from "@angular/core";
import { toSignal } from "@angular/core/rxjs-interop";
import { MatTabLink, MatTabNav, MatTabNavPanel } from "@angular/material/tabs";
import {
  ActivatedRoute,
  RouterLink,
  RouterLinkActive,
  RouterOutlet,
} from "@angular/router";
import { IconComponent } from "@claas/claas-ui-components";
import { TranslatePipe } from "@ngx-translate/core";
import { AppSectionHeader } from "../../shared/components/app-section-header/app-section-header";
import { CompetitorSelectionDialog } from "../../shared/components/competitor-selection-dialog/competitor-selection-dialog";
import { MainModalDialog } from "../../shared/components/main-modal-dialog/main-modal-dialog";
import {
  pathParamsHelper,
  pathRouteDataHelper$,
  pathRouteParametersHelper$,
} from "../../shared/helpers/path-params.helper";
import { DefaultProduct } from "../../shared/pia-api/generated";

@Component({
  selector: "claas-product-arguments-tech-data",
  imports: [
    AppSectionHeader,
    RouterLink,
    MatTabLink,
    RouterLinkActive,
    MatTabNav,
    MatTabNavPanel,
    RouterOutlet,
    IconComponent,
    TranslatePipe,
    MainModalDialog,
    CompetitorSelectionDialog,
  ],
  templateUrl: "./product-arguments-tech-data.html",
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrl: "./product-arguments-tech-data.scss",
})
export class ProductArgumentsTechDataComponent {
  route = inject(ActivatedRoute);

  showMainModal = false;

  data = toSignal(pathRouteDataHelper$());
  routeParams = toSignal(pathRouteParametersHelper$());
  argumentsTabActive = computed(() => {
    const { deepPath } = pathParamsHelper(this.route.snapshot);
    return deepPath?.includes("product") && deepPath?.includes("arguments");
  });
  techDataTabActive = computed(() => {
    const { deepPath } = pathParamsHelper(this.route.snapshot);
    return deepPath?.includes("product") && deepPath?.includes("tech-data");
  });
  productTitle = computed(() => {
    return this.data()?.["productDescendants"]?.find(
      (productDescendant?: DefaultProduct) =>
        productDescendant?.ID &&
        this.routeParams()?.["productId"] &&
        productDescendant?.ID === this.routeParams()?.["productId"],
    )?.Name as string | null;
  });
  productCompetitors = computed(() => this.data()?.["competitors"]);

  setShowMainModal(val: boolean) {
    this.showMainModal = val;
  }
}
